angular.module(NgAppName).component('crBuyersInterested', {
	templateUrl: 'crBuyersInterested.html',
	bindings: {
		rpc: '@',
		buildingType: '@',
		isNewDev: '<',
		graphId: '@',
		pageId: '@',
		onNoResults: '&'
	},
	controller: ['$element', '$window', '$timeout', '$scope', '$location', '$filter' ,'gVariables', 'PubSub', 'crResourcesService', 'StateService', function($element, $window, $timeout, $scope, $location, $filter, gVariables, PubSub, crResourcesService, StateService) {
		var self = this;

		this.onMobile = true;
		this.loaded = false; 
		this.firstLoad = true;

		this.$onInit = () => {

			if (this.isNewDev) {
				this.buildingTableType = 'buildingUnitsNewDev';
			} else {
				this.buildingTableType = this.buildingType == 3 || this.buildingType == 7 ? 'buildingUnitsCoop' : 'buildingUnits';
			}
			

			this.categoriesLabel = {
				10: 'Studios',
				11: '1 Beds',
				12: '2 Beds',
				13: '3 Beds',
				14: '4 Beds',
				15: '5 Beds',
				16: '6 Beds+'
			};

			let cookie = StateService.get(this.pageId); 
			let currentPage;
			if (cookie) {
				this.sortings = cookie['list'];
			}

			let location = $location.url();
			let searchParams = new URLSearchParams(location);
			let page = searchParams.get('page') || searchParams.get('/page');

			this.loadData(page);
		};

		this.loadData = (currentPage) => {
			let url = this.rpc;
			if (this.sortings) {
				let page = this.pagination ? this.pagination.currentPage : currentPage;
				url += '&sort=' + this.sortings.sort + '&dir=' + this.sortings.dir + '&page=' + page;
			}  
  
			crResourcesService.get(url).$promise.then((data) => {
				if (data) {

					if (data && data.data) {
						let beds = [];
						let values = []
						angular.forEach(data.data, (d) => {
							beds.push(d.beds);
							values.push(parseInt(d.buyers, 10));
						});

						this.generateGraph(beds, values);

						// total buyers
						const nbBuyers = values.reduce((partialSum, a) => partialSum + a, 0);
	
						if (nbBuyers === 0) {
							this.onNoResults();
						}
					}

					this.loaded = true;
				}
			}, (error) => {
				// todo manage errors
			}).finally(() => {
				// hide loader
				if (this.firstLoad) {
					this.firstLoad = false;
				}
			});
		};


		this.generateGraph = (beds, values) => {
			Highcharts.chart('graph-' + this.graphId , {
				chart: {
					type: 'bar',
					backgroundColor: '#f7f7f7'
				},
				exporting: {
					enabled: true
				}, 
				title: {
					text: ''
				},
				subtitle: { 
					text: ''
				},
				xAxis: {
					categories: beds,
					title: {
						text: null
					},
					labels: {
						align: 'center',
						style: {
							fontSize: "12px"
						}
					}
				},
				yAxis: {
					min: 0,
					title: {
						text: '',
						align: 'high'
					},
					labels: {
						overflow: 'justify',
						style: {
							fontSize: "12px",
						},
						useHTML: true,
						formatter: (data) => {
							let html = `${$filter('numberWithCommas')(data.value, 2)}`;
							return html;
						}
					}
				},
				tooltip: {
					useHTML: true,
					pointFormatter: function(data) { 
						return '<span class="active-buyers">' + $filter('numberWithCommas')(this.y, 2) + ' active buyer' + (this.y > 1 ? 's' : '') + '</span>';	
					}
				},
				plotOptions: {
					bar: {
						dataLabels: {
							enabled: true,
							format: ' '
						},
						pointWidth: 10
					}
				},
				legend: {
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'top',
					x: -40,
					y: 80,
					floating: true,
					// borderWidth: 1,
					backgroundColor: 'transparent',
					shadow: true
				},
				credits: {
					enabled: false
				},
				series: [{
					showInLegend: false, 
					name: ' ',
					data: values
				}
				]
			});
		};



	}]
});
